import React from 'react'

interface FeeItemProps {
  label: string
  value: string
}

export const FeeItem = ({ label, value }: FeeItemProps) => (
  <li className="grid gap-4">
    <span className="ton-paragraph-12">{label}</span>

    <span className="font-heading text-newTon-700 ton-paragraph-28">
      {value}
    </span>
  </li>
)
